"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const environmentVariables = {
    MIXPANEL_TOKEN: process.env.SAFETY_INTELLIGENCE_MIXPANEL_TOKEN,
};
exports.default = environmentVariables;
